import React from 'react';
import PropTypes from 'prop-types';
import { Carousel, Column, Container, Row } from '@pella/sash-framework';
import Card from '../card';

const Cards = ({ data, slidePadding = 16, className }) => {
	if (!data?.cards?.[0]) return null;

	return (
		<div className={`pd-cards py-8 md:py-12 ${className || ''}`}>
			<Container>
				{data.heading && (
					<div
						className='relative m-0 text-center before:absolute before:left-0 before:top-1/2 before:h-px before:w-full before:-translate-y-1/2 before:bg-gray-15 before:content-[""] [&_h2]:relative [&_span]:bg-white [&_span]:px-4'
						dangerouslySetInnerHTML={{ __html: data.heading }}
					/>
				)}

				{data.description && (
					<div
						className='mt-2'
						dangerouslySetInnerHTML={{ __html: data.description }}
					/>
				)}

				{!data.carousel && (
					<Row
						className={`${data.heading || data.description ? 'mt-6 md:mt-8' : ''}`}
						justify='center'
						verticalGutters
					>
						{data.cards.map((card, index) => (
							<Column
								key={index}
								{...JSON.parse(data.slides)}
							>
								<Card
									data={card}
									variant={card.variant}
								/>
							</Column>
						))}
					</Row>
				)}

				{data.carousel && (
					<Carousel
						slidesToShow={JSON.parse(data.slides)}
						slidePadding={slidePadding}
						arrowsClassName='max-md:!hidden'
						wrapperClassName='mt-6 md:mt-8'
						className='pb-5'
						showArrows
						showDots
					>
						{data.cards.map((card, index) => (
							<Card
								data={card}
								variant={card.variant}
								key={index}
							/>
						))}
					</Carousel>
				)}
			</Container>
		</div>
	);
};

Cards.propTypes = {
	data: PropTypes.object.isRequired,
	slidePadding: PropTypes.number,
	className: PropTypes.string,
};

export default Cards;
